var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1842.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Thumbs/up",
    transform: "translate(1206.000000, 1842.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33361382,20.474 C3.55461094,23.51 4.12761306,26.723 6.18162066,29.061 C7.46762542,30.526 9.14763164,31.439 10.9676384,31.8 C11.40764,31.923 11.8706417,31.999 12.3596435,32 L20.5226737,31.657 C22.3106804,31.597 23.9356864,30.431 24.6896892,28.81 C26.3276952,24.914 27.4266993,20.76 27.8727009,16.445 C27.9197011,15.977 27.9597013,15.511 27.9927014,15.047 L27.9847014,15.027 C28.1417019,13.501 27.072698,12.266 25.5876925,12.228 L11.6266408,12.106 L12.216643,4.686 C12.4266438,2.757 11.673641,0.55 9.75363388,0 L4.33361382,20.474 Z",
    id: 203
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonThumbsUp);
export default __webpack_public_path__ + "static/media/common-thumbs-up.054459e0.svg";
export { ForwardRef as ReactComponent };